module.exports = __webpack_public_path__ + "static/media/number-icon.96274c78.svg";